import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { buildPublicExperienceStyles } from '../../../services/global.service';
import { CommonModule } from '@angular/common';
import { NgxQrcodeStylingComponent, Options } from 'ngx-qrcode-styling';
import { ProductDesignTemplatePageModuleDataContent } from '../../../store/app.model';
import { LineBreakPipe } from '../../../pipes/line-break.pipe';

@Component({
  selector: 'app-qr-code',
  imports: [
    CommonModule,
    NgxQrcodeStylingComponent,
    LineBreakPipe
  ],
  templateUrl: './qr-code.html',
})
export class QrCode implements OnChanges, OnInit {
  @Input({ required: true }) content!: any;
  @Input({ required: true }) styles!: any;
  @Input({ required: true }) isSelectedModule!: boolean;
  @Input({ required: true }) isFirstModule!: boolean;
  @Input({ required: true }) isLastModule!: boolean;

  @ViewChild(NgxQrcodeStylingComponent, { static: false })
  qrCode!: NgxQrcodeStylingComponent;

  items: ProductDesignTemplatePageModuleDataContent[] = [];
  qrConfig!: Options;

  constructor(private readonly cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.qrCode?.update(this.qrConfig, this.qrConfig);
    this.cd.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.content) {
      if (
        'pageModuleTemplateDataContents' in this.content &&
        Array.isArray(this.content.pageModuleTemplateDataContents)
      ) {
        this.items = this.content.pageModuleTemplateDataContents;
      } else if (
        'contentItems' in this.content &&
        Array.isArray(this.content.contentItems)
      ) {
        this.items = this.content.contentItems;
      } else if (
        'components' in this.content &&
        Array.isArray(this.content.components)
      ) {
        this.items = this.content.components;
      } else {
        this.items = [];
      }
    } else {
      this.items = [];
    }
    this.items = this.sortItemsByOrder(this.items);
  }

  private sortItemsByOrder(
    items: ProductDesignTemplatePageModuleDataContent[],
  ): ProductDesignTemplatePageModuleDataContent[] {
    return [...items].sort((a, b) => (Number(a.order) || 0) - (Number(b.order) || 0));
  }

  buildStyle(type: string, style: any): string {
    return buildPublicExperienceStyles(type, style);
  }

  /**
   * Ensures QR headline/body text is readable (black on light backgrounds) when styles are
   * missing, empty, or set to white — matches admin preview behavior (REG-1996).
   */
  getReadableQrTextStyle(style: any): string {
    const defaults = {
      color: '#000000',
      fontSize: '16px',
      fontWeight: 'normal',
      fontFamily: 'inherit',
      textAlign: 'center',
      lineHeight: 'normal',
    };
    const merged: Record<string, string> = { ...defaults, ...(style || {}) };
    const colorStr =
      typeof merged['color'] === 'string' ? merged['color'].trim().toLowerCase() : '';
    const needsReadableBlack =
      !colorStr ||
      ['#fff', '#ffffff', 'white'].includes(colorStr) ||
      colorStr === 'rgb(255, 255, 255)' ||
      colorStr === 'rgba(255, 255, 255, 1)';
    if (needsReadableBlack) {
      merged['color'] = '#000000';
    }
    const built = this.buildStyle('text', merged);
    return needsReadableBlack ? `${built}; color: #000000 !important` : built;
  }

  getProductQrSettings(item: ProductDesignTemplatePageModuleDataContent): Options {
    if (!item) {
      this.qrConfig = {};
      return this.qrConfig;
    }

    this.qrConfig = {
      data: item.value.url,
      type: 'svg',
      width: 100,
      height: 100,
      dotsOptions: {
        color: item.styles?.qr?.color,
      },
      cornersDotOptions: {
        color: item.styles?.qr?.color,
      },
      cornersSquareOptions: {
        color: item.styles?.qr?.color,
      },
    };
    return this.qrConfig;
  }
}
